import { render } from "./wSelectFromServer.vue?vue&type=template&id=7f322498&ts=true"
import script from "./wSelectFromServer.vue?vue&type=script&lang=ts"
export * from "./wSelectFromServer.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__